export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";